module.exports = __webpack_public_path__ + "static/img/shiyecover.4699a55a.png";